// src/utils/axiosConfig.js
import axios from 'axios';

// --- Base URL (works in your deployment) ---
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

//Send cookies (sessionid, csrftoken) with every request
axios.defaults.withCredentials = true;

// --- Attach token on every request ---
axios.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) {
    cfg.headers = { ...(cfg.headers || {}), Authorization: `Token ${token}` };
  }
  return cfg;
});

// --- Helper: detect auth-free endpoints (login, register, reset, verify, etc.) ---
const isPublicAuthUrl = (url = '') => {
  // Works for absolute or relative URLs; case-insensitive; trailing slashes optional
  const u = String(url).toLowerCase();
  return /\/(login|register|check-email|resend-activation|generate-reset-token|verify(?:-email)?|reset-password(?:-confirm)?|verify-password)\b/.test(
    u
  );
};

// --- Response: prevent global redirects on auth-free calls or when skipped ---
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const cfg = err?.config || {};
    const headers = cfg.headers || {};
    const hasToken = !!localStorage.getItem('token');

    // Allow page-level opt-out (case-insensitive header) or explicit flag
    const skip =
      headers['X-Skip-Auth-Redirect'] === '1' ||
      headers['x-skip-auth-redirect'] === '1' ||
      cfg.__skipAuthRedirect === true;

    const url = cfg.url || '';

    // Only consider redirecting on protected requests when user HAD a token
    const shouldRedirect =
      (status === 401 || status === 403) && hasToken && !skip && !isPublicAuthUrl(url);

    if (shouldRedirect) {
      // Global sign-out → send user HOME (not /login)
      localStorage.removeItem('token');
      localStorage.removeItem('user_type');
      localStorage.setItem('logout_at', String(Date.now()));

      // Avoid redundant reloads
      if (window.location.pathname !== '/') {
        window.location.assign('/');
      }
    }

    // Always reject so callers can handle their own UI messages
    return Promise.reject(err);
  }
);

export default axios;
